// blogThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as blogService from "../../../services/blog";
import { toast } from "react-toastify";
// Get all blogs (paginated)
export const fetchBlogs = createAsyncThunk(
  "blogs/fetchBlogs",
  async (_, thunkAPI) => {
    try {
      const { status, data } = await blogService.getBlogs();
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  }
);

export const FeaturedBlogs = createAsyncThunk(
  "blogs/FeaturedBlogs",
  async (_, thunkAPI) => {
    try {
        const { status, data } = await blogService.getFeaturedBlogs();
        if (status === 200) {
            // console.log('featured Data', data?.data)
            return data?.data;
        } else if (status === 401) {
            toast.error(data?.message);
        } else {
            toast.error(data?.message);
        }
    } catch (error) {
      toast.error(error?.message);
    }
  }
);

// Get single blog by ID
export const fetchBlogById = createAsyncThunk(
  "blogs/fetchBlogById",
  async (blogId, thunkAPI) => {
    try {
      const { status, data } = await blogService.getBlogById(blogId);
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  }
);

// Create a new blog
export const createNewBlog = createAsyncThunk(
  "blogs/createBlog",
  async (blogData, thunkAPI) => {
    try {
      const { status, data } = await blogService.createBlog(blogData);
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  }
);

// Update existing blog
export const updateExistingBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ blogId, blogData }, thunkAPI) => {
    try {
      const { status, data } = await blogService.updateBlog(blogId, blogData);
      if (status === 200) {
        return data?.data;
      } else {
        return thunkAPI.rejectWithValue(data?.message || "Update failed");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || error.message
      );
    }
  }
);

// Delete blog
export const deleteBlogById = createAsyncThunk(
  "blogs/deleteBlog",
  async (blogId, thunkAPI) => {
    /*  try {
    await blogService.deleteBlog(blogId);
    return blogId;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  } */
    try {
      const { status, data } = await blogService.deleteBlog(blogId);
      if (status === 200) {
        return data?.data;
      } else if (status === 401) {
        toast.error(data?.message);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  }
);
